var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_c('div',{staticClass:"d-inline-block select-status",class:("select-status--" + (_vm.$options.statusColor(_vm.props)))},[_vm._v(" "+_vm._s(_vm.props.status)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }